import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AgentService, ICurrency } from 'src/app/apis/agent.service';
import { AppCore } from 'src/app/utils/classes/app-core';
import { alertDanger } from 'src/app/utils/functions/alert';

@Component({
  selector: 'app-input-curency',
  templateUrl: './input-curency.component.html',
  styleUrls: ['./input-curency.component.scss']
})
export class InputCurencyComponent extends AppCore implements OnInit {
  @Input() disabled: boolean = false;
  @Input() currency: string;
  @Output() currencyChange = new EventEmitter<string>();

  currencys: ICurrency[] = [];
  constructor(private svAgent: AgentService) {
    super();
  }

  getCurrency() {
    this.svAgent.getCurrency().subscribe((e: ICurrency[]) => {
      this.currencys = e;
    });
  }
  ngOnInit() {
    this.getCurrency();
  }
  onSubmit(currency: ICurrency) {
    if (currency.supported === false) {
      return;
    }
    if (this.disabled == true) {
      alertDanger({ message: 'disabled for change currency' });
      return;
    }
    this.currency = currency.currency;
    this.currencyChange.emit(currency.currency);
  }
}
